import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import Chip from "@mui/material/Chip";
import { StatusConstants, getStatusStyles } from "../../helpers/Constants";

const StatusSelectionPopup = ({
  setStatusPopup,
  value,
  rowId,
  handleStatusChange,
  setTableLoad,
}) => {
  const currentStatusLabel = StatusConstants[value];

  const handleOptionSelect = async (optionValue) => {
    if (optionValue !== value) {
      setTimeout(() => {
        setTableLoad(true);
      }, 100);

      setStatusPopup(false);
      const data = {
        status: optionValue,
      };
      try {
        const response = await window.apiHelper.getUpdateStatus(rowId, data);

        if (response) {
          handleStatusChange(true);
        } else {
          handleStatusChange(false);
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      // closes the popup if the selected option is the same as the current value 
      setStatusPopup(false);
    }
  };

  return (
    <MenuList style={{ padding: "0px" }}>
      {Object.entries(StatusConstants).map(([ statusValue, statusLabel ]) => (
        <MenuItem
          key={statusValue}
          selected={statusLabel === currentStatusLabel}
          onClick={() => handleOptionSelect(parseInt(statusValue))}
        >
          <Chip label={statusLabel} sx={getStatusStyles(parseInt(statusValue))} />
        </MenuItem>
      ))}
    </MenuList>
  );
};

export default StatusSelectionPopup;